import React, { useState, useEffect } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { apisPath } from "../../utils/path";
import { authHttp } from "../../services/commonHttpService";

const PremedicationDrugNameSuggest = ({
    name,
    value,
    onChange,
    onBlur,
    drug_type = "", // Added to filter search
    label = "Drug Name",
    error = false,
    helperText = "",
    disabled = false,
    size = "small",
    variant = "standard"
}) => {
    const [options, setOptions] = useState([]);
    const [inputValue, setInputValue] = useState(value || "");

    useEffect(() => {
        const fetchSuggestions = async () => {
            // Only search if we have a drug_type and at least 1 character
            if (!drug_type || inputValue.length < 1) {
                setOptions([]);
                return;
            }
            try {
                const res = await authHttp.get(`${apisPath?.masters?.preMedicationDrugSearch}?drug_type=${encodeURIComponent(drug_type)}&search=${encodeURIComponent(inputValue)}`);
                if (res?.data?.data) {
                    setOptions(res?.data?.data);
                }
            } catch (err) {
                console.error("Error fetching drug name suggestions:", err);
            }
        };

        const timeoutId = setTimeout(() => {
            fetchSuggestions();
        }, 100); // Debounce: trigger search after 100ms of no typing

        return () => clearTimeout(timeoutId);
    }, [inputValue, drug_type]);

    return (
        <Autocomplete
            freeSolo
            id={name}
            // Options are objects { drug_id, drug_name }
            options={options}
            getOptionLabel={(option) => (typeof option === 'string' ? option : option.drug_name)}
            value={value || ""}
            onChange={(event, newValue) => {
                // newValue can be a string (manual entry) or an object (selected option)
                const finalValue = typeof newValue === 'string' ? newValue : (newValue?.drug_name || "");
                if (onChange) {
                    const e = {
                        target: {
                            name: name,
                            value: finalValue
                        }
                    };
                    onChange(e);
                }
            }}
            onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
                // Also update formik value on every keystroke if it's a freeSolo
                if (onChange) {
                    const e = {
                        target: {
                            name: name,
                            value: newInputValue
                        }
                    };
                    onChange(e);
                }
            }}
            onBlur={onBlur}
            disabled={disabled || !drug_type}
            renderInput={(params) => (
                <TextField
                    {...params}
                    name={name}
                    label={label}
                    error={error}
                    helperText={helperText}
                    size={size}
                    variant={variant}
                    InputLabelProps={{ shrink: true }}
                />
            )}
        />
    );
};

export default PremedicationDrugNameSuggest;
